import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';

import { FlashyTokenService } from '@flashy/users/data-access';

export const authorisationInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const tokenService = inject(FlashyTokenService);
  if (
    tokenService.token &&
    [
      'spa.flashy',
      'bqa.flashy',
      'application.cbox',
      'application.test',
      'application.flashy.dev',
    ].some((domain) => req.url.includes(domain))
  ) {
    const convertorEndpoint = localStorage.getItem('convertor_endpoint');

    let modifiedReq = req.clone({
      withCredentials: true,
      headers: req.headers.set('Authorization', `Bearer ${tokenService.token}`),
    });

    if (convertorEndpoint) {
      modifiedReq = modifiedReq.clone({
        headers: modifiedReq.headers.set(
          'X-Convertor-Endpoint',
          convertorEndpoint
        ),
      });
    }

    return next(modifiedReq);
  }
  return next(req);
};
